export default __webpack_public_path__ + "static/painting3-8e57e2a3ac28529895bd410f16269edc.jpg";